
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getRetrieveUser } from './redux/actions/userActions';
import { getUserId, getUsername } from './utils/storageFunction';

const PrivateRouteAdm = ({ children }) => {
    const isLogged = localStorage.getItem('access_token') ? true : false;
    const dispatch = useDispatch();
    const dataUser = useSelector(state => state.userReducer)
    const [viewCorrect, setViewCorrect] = React.useState(null)

    useEffect(() => {
        if (isLogged) {
            let user = {
                username: getUsername(),
                user_id: getUserId()
            }
            dispatch(getRetrieveUser(user))
        }
    }, [isLogged])

    useEffect(() => {
        if ((dataUser?.retrieve !== null && dataUser?.retrieve?.data?.is_staff) && isLogged) {
            setViewCorrect(children);
        }
        else {
            let viewHome = <Navigate to="/home" replace></Navigate>
            setViewCorrect(viewHome)
        }
    }, [dataUser?.retrieve, children])


    return viewCorrect;

}

export default PrivateRouteAdm;